import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  filterByCategory,
  setTabValue,
} from "../../../redux/actions/BookClosure/actionBookClosure";
import PropTypes from "prop-types";
import CategoryBsAndPnl from "./CategoryBsAndPnl";

import buttoncss from "../../../myfin_v2/css/button.module.css";
import commoncss from "../../../myfin_v2/css/common.module.css";
import bookclosuretbcss from "../../../myfin_v2/css/bookclosuretb.module.css";
import Dropdown from "../../../myfin_v2/elements/Dropdown";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography> {children} </Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const TemplateTab = ({ dragData, bookClosureTbId }) => {
  const dispatch = useDispatch();
  const { filters, tabValue, groupings, catItems, asOnDateFormatted, financialYearStartFormatted } = useSelector(
    (initialState) => initialState.BookClosureTbcReducer
  );

  const [selectedFilter, setSelectedFilter] = useState(null);

  if (!asOnDateFormatted || !financialYearStartFormatted) return null;

  return (
    <>
      <div>
        <div className={`${bookclosuretbcss.tempNotesSection}  px-2`}>
          <Dropdown
            class_={commoncss.w60pct}
            class2_={commoncss.bgWhite}
            options={filters.map(item => ({
              label: item,
              value: item
            }))}
            onSelect={(option) => setSelectedFilter(option.value)}
            placeHolder={"Notes"}
          />

          <div className="button-group" style={{width:"150px"}}>
            <button
              className={`${buttoncss.custom_btn} ${
                tabValue === 0 ? buttoncss.primary : buttoncss.secondary
              }`}
              style={{
                "border-radius": "8.18px 0px 0px 8.18px",
                padding: "5px 7px",
                "min-width": "68px",

                ...(tabValue === 1 && { background: "#f5f5f5" }),
              }}
              onClick={() => {
                dispatch(setTabValue(0));
                dispatch(filterByCategory({ groupings, type: "BS" }));
              }}
            >
              BS
            </button>
            <button
              className={`${buttoncss.custom_btn} ${
                tabValue === 1 ? buttoncss.primary : buttoncss.secondary
              }`}
              style={{
                "border-radius": "0 8.18px 8.18px 0",
                "padding": "5px 7px",
                "min-width": "68px",
                ...(tabValue !== 1 && { background: "#f5f5f5" }),
              }}
              onClick={() => {
                dispatch(setTabValue(1));
                dispatch(filterByCategory({ groupings, type: "PNL" }));
              }}
            >
              P&L
            </button>
          </div>
        </div>

        <Box className="MuiBox-rootTab  px-2" sx={{ width: "100%" }}>
          <TabPanel value={tabValue} index={0}>
            <CategoryBsAndPnl
              headers={[
                'Particulars',
                'Notes',
                asOnDateFormatted ? `AS AT ${asOnDateFormatted}` : '',
                financialYearStartFormatted ? `AS AT ${financialYearStartFormatted}` : '',
              ]}
              rows={catItems}
              dragData={dragData}
              asOnDateFormatted={asOnDateFormatted}
              financialYearStartFormatted={financialYearStartFormatted}
              selectedFilter={selectedFilter}
              bookClosureTbId={bookClosureTbId}
            />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <CategoryBsAndPnl
              headers={[
                "Particulars",
                "Notes",
                asOnDateFormatted ? `AS AT ${asOnDateFormatted}` : '',
                financialYearStartFormatted ? `AS AT ${financialYearStartFormatted}` : '',
              ]}
              rows={catItems}
              dragData={dragData}
            />
          </TabPanel>
        </Box>
      </div>
    </>
  );
};

export default TemplateTab;
